import { all, takeEvery, put } from 'redux-saga/effects';
import invoiceActions from '../invoice/actions';
import actions from './actions';
import {
  simpleQueryFirestoreWithFilter,
  simpleQueryFirestoreWithFilterOrderBy,
  joinCollections,
  firestoreCollectionToArray,
  addPropertyToCollection,
  firestoreCollectionToContainsArray,
  createCleanServiceRows,
  sortJoinCollectionsData,
  chunkFilter,
} from '../../components/utility/firestore.helper';
import { rsf, db } from '@iso/lib/firebase/firebase';
import firebase from '@iso/lib/firebase/firebase';
import { call } from 'redux-saga/effects';
import omit from 'lodash/omit';
import { convertCollectionsSnapshotToArray } from '@iso/lib/firebase/firebase.util';
import { getValidNextReservationNumber, getTimezonesArray } from './saga-helper';
import DateFormatter from "../../components/utility/DateFormatter";
import { getAccountIdPrefix } from '@iso/components/library/helpers/local_storage';
import { BOOKING_NOTIFICATION_EMAIL } from '@iso/config/bookingPermissions';

const COLLECTION_NAME_BOOKING = 'bookings';
const COLLECTION_NAME_PROPERTIES = 'properties';

function* loadBooking(query) {
  try {
    const filterBooking = { 'booking': { 'value': query.payload.id, 'operator': '==', 'field': 'id' } };
    const data = yield simpleQueryFirestoreWithFilter(getAccountIdPrefix() + COLLECTION_NAME_BOOKING, filterBooking);
    const dataSource = [];
    Object.keys(data).map((item, index) => {
      return dataSource.push({
        ...data[item],
        key: item,
      });
    });
    yield put(actions.loadBookingSuccess(dataSource[0]));
  }
  catch (error) {
    yield put(actions.loadBookingError(error));
  }
}

function* loadBookings(query) {
  try {
    const filtersBooking = query && query.payload.filterBooking;
    const data = yield firestoreCollectionToArray(getAccountIdPrefix() + COLLECTION_NAME_BOOKING, filtersBooking);
    yield put(actions.loadBookingsSuccess(data));


  }
  catch (error) {
    yield put(actions.loadBookingsError(error));
  }
}

function* getNextReservationNumber() {
  try {
    let collectionRef = db.collection(getAccountIdPrefix() + COLLECTION_NAME_BOOKING).orderBy('reservation_number', 'desc').limit(1)
    const snapshots = yield call(rsf.firestore.getCollection, collectionRef);
    const data = yield call(convertCollectionsSnapshotToArray, snapshots);
    const nextReservationNumber = getValidNextReservationNumber(data);
    return nextReservationNumber
  }
  catch (error) {
    yield put(actions.getNextReservationNumberError(error));
  }
}

function* loadBookingsWithProperties(query) {

  try {
    let filtersBooking = query && query.payload.filterBooking;
    let filterBookingQuery = [];
    if (!filtersBooking) filtersBooking = {};
    if (filtersBooking.start_date) {
      filterBookingQuery.push(
        {
          field: "start_date",
          operator: ">=",
          value: filtersBooking.start_date.value,
        })
    }
    else {
      let d = new Date();
      filterBookingQuery.push(
        {
          field: "start_date",
          operator: ">=",
          value: DateFormatter.getValueOfDate(d.setMonth(d.getMonth() - 6)),
        });
    }

    if (filtersBooking.property) {
      filterBookingQuery.push(
        {
          field: "property_id",
          operator: "==",
          value: filtersBooking.property.value,
        });
    }

    if (filtersBooking.name) {
      filterBookingQuery.push(
        {
          field: "name",
          operator: "==",
          value: filtersBooking.name.value,
        });
    }

    if (filtersBooking.surname) {
      filterBookingQuery.push(
        {
          field: "surname",
          operator: "==",
          value: filtersBooking.surname.value,
        });
    }

    if (filtersBooking.end_date) {
      filterBookingQuery.push(
        {
          field: "start_date",
          operator: "<=",
          value: filtersBooking.end_date.value,
        });
    }

    if (filtersBooking.status) {
      filterBookingQuery.push(
        {
          field: "status",
          operator: filtersBooking.status.operator,
          value: filtersBooking.status.value,
        });
    }
    const filtersProperty = query && query.payload.filterProperty;
    const orderBy = { type: 'desc', field: 'start_date' };
    let bookingData = yield simpleQueryFirestoreWithFilterOrderBy(getAccountIdPrefix() + COLLECTION_NAME_BOOKING, filterBookingQuery, orderBy);
    let propertyData = yield simpleQueryFirestoreWithFilter(getAccountIdPrefix() + COLLECTION_NAME_PROPERTIES, filtersProperty);
    const data = yield joinCollections(bookingData, propertyData, 'property_id', 'property');
    yield put(actions.loadBookingsWithPropertiesSuccess(data));
  }
  catch (error) {
    console.log(error);
    yield put(actions.loadBookingsWithPropertiesError(error));
  }
}


function* loadArrivalDepartureWithProperties(query) {
  try {
    const filtersBooking = query && query.payload.filterBooking;
    const filtersProperty = query && query.payload.filterProperty;
    
    // Validar que existan los filtros necesarios
    if (!filtersBooking) {
      yield put(actions.loadArrivalDepartureWithPropertiesError(new Error('Filtros de booking requeridos')));
      return;
    }

    // Construir filtros base comunes
    const baseFilters = filtersBooking.status ? { status: filtersBooking.status } : {};
    
    // Construir filtros específicos para cada tipo de consulta
    const arrivalFilters = {
      ...baseFilters,
      ...(filtersBooking.start_date_arrival && { start_date: filtersBooking.start_date_arrival }),
      ...(filtersBooking.end_date_arrival && { end_date: filtersBooking.end_date_arrival })
    };
    
    const departureFilters = {
      ...baseFilters,
      ...(filtersBooking.start_date_departure && { start_date: filtersBooking.start_date_departure }),
      ...(filtersBooking.end_date_departure && { end_date: filtersBooking.end_date_departure })
    };

    // Ejecutar consultas en paralelo para mejor rendimiento
    const [bookingDataArrival, bookingDataDeparture, propertyData] = yield all([
      firestoreCollectionToArray(getAccountIdPrefix() + COLLECTION_NAME_BOOKING, arrivalFilters),
      firestoreCollectionToArray(getAccountIdPrefix() + COLLECTION_NAME_BOOKING, departureFilters),
      firestoreCollectionToArray(getAccountIdPrefix() + COLLECTION_NAME_PROPERTIES, filtersProperty)
    ]);

    // Procesar datos de limpieza si existen
    let bookingDataClean = [];
    if (filtersBooking.clean_services && Array.isArray(filtersBooking.clean_services) && filtersBooking.clean_services.length > 0) {
      bookingDataClean = yield processCleanServicesData(filtersBooking.clean_services);
    }

    // Procesar y combinar todos los datos
    const processedData = processBookingData({
      arrival: bookingDataArrival,
      departure: bookingDataDeparture,
      clean: bookingDataClean,
      cleanServices: filtersBooking.clean_services
    });

    // Unir con datos de propiedades
    const data = yield joinCollections(processedData, propertyData, 'property_id', 'property');

    yield put(actions.loadArrivalDepartureWithPropertiesSuccess(data));
  }
  catch (error) {
    console.error('Error en loadArrivalDepartureWithProperties:', error);
    yield put(actions.loadArrivalDepartureWithPropertiesError(error));
  }
}

// Función helper para procesar datos de servicios de limpieza
function* processCleanServicesData(cleanServices) {
  try {
    const cleanServicesChunks = chunkFilter(cleanServices, 10);
    const allCleanData = [];
    
    // Procesar chunks en paralelo para mejor rendimiento
    const chunkPromises = cleanServicesChunks.map(chunk => 
      processCleanServicesChunk(chunk)
    );
    
    const chunkResults = yield all(chunkPromises);
    return chunkResults.flat();
  } catch (error) {
    console.error('Error procesando servicios de limpieza:', error);
    return [];
  }
}

// Función helper para procesar un chunk de servicios de limpieza
function* processCleanServicesChunk(cleanServicesChunk) {
  try {
    const timezoneArray = getTimezonesArray(cleanServicesChunk);
    const timezoneChunks = chunkFilter(timezoneArray, 10);
    
    // Procesar chunks de timezone en paralelo
    const timezonePromises = timezoneChunks.map(timezoneChunk =>
      firestoreCollectionToContainsArray(getAccountIdPrefix() + COLLECTION_NAME_BOOKING, timezoneChunk)
    );
    
    const timezoneResults = yield all(timezonePromises);
    return timezoneResults.flat();
  } catch (error) {
    console.error('Error procesando chunk de servicios de limpieza:', error);
    return [];
  }
}

// Función helper para procesar y combinar datos de booking
function processBookingData({ arrival, departure, clean, cleanServices }) {
  // Agregar propiedades de tipo a cada conjunto de datos
  const processedArrival = addPropertyToCollection(arrival, 'arrival');
  const processedDeparture = addPropertyToCollection(departure, 'departure');
  
  // Procesar datos de limpieza si existen
  let processedClean = [];
  if (clean && clean.length > 0 && cleanServices) {
    processedClean = createCleanServiceRows(clean, cleanServices);
    processedClean = addPropertyToCollection(processedClean, 'clean');
  }

  // Combinar todos los datos
  const allBookingData = [...processedArrival, ...processedDeparture, ...processedClean];
  
  // Ordenar datos combinados
  return sortJoinCollectionsData(allBookingData);
}

export function* deleteBooking({ payload }) {
  const { data, filterBooking, acknowledgeFinalInvoices } = payload;
  try {
    // BR2: a booking whose lines are in a GENERATED invoice (anything that is not a draft) can be deleted, but
    // the user must know first that those invoices will NOT change: a generated invoice is never edited or
    // deleted, so the charge is cancelled with a credit note. Nothing is written until they confirm; only
    // the DRAFT lines of the booking are cleaned afterwards (the sync never touches a generated invoice).
    if (data.property_id && data.id && !acknowledgeFinalInvoices) {
      const invoiceFilters = [
        { field: 'invoiceProperty', operator: '==', value: data.property_id },
        { field: 'deleted_at',      operator: '==', value: null },
      ];
      const allPropertyInvoices = yield simpleQueryFirestoreWithFilter(
        getAccountIdPrefix() + 'invoices',
        invoiceFilters
      );
      const finalizedWithBookingItems = Object.values(allPropertyInvoices).filter(inv =>
        inv.orderStatus !== 'draft' &&
        inv.invoiceList &&
        inv.invoiceList.some(line => line.bookingId === data.id)
      );
      if (finalizedWithBookingItems.length > 0) {
        const invoiceNumbers = Array.from(new Set(finalizedWithBookingItems.map(inv => inv.number))).sort();
        yield put({
          type: actions.DELETE_BOOKING_NEEDS_CONFIRMATION,
          payload: { booking: data, filterBooking, invoiceNumbers },
        });
        return;
      }
    }

    // Clean up all draft invoice lines from this booking BEFORE deleting it
    // (per business rule: booking deletion removes all related draft lines)
    const allItems = [
      ...(data.arrival_item_list || []),
      ...(data.departure_item_list || []),
      ...(data.cleaning_services_item_list || []),
    ].map(item => ({ ...item, deleted: true }));

    if (allItems.length > 0 && data.property_id && data.id) {
      yield put({
        type: invoiceActions.UPDATE_INVOICE_ITEM_BOOKING,
        payload: {
          items: allItems,
          bookingId: data.id,
          propertyId: data.property_id,
        }
      });
    }

    yield call(rsf.firestore.deleteDocument, getAccountIdPrefix() + COLLECTION_NAME_BOOKING + '/' + data.key)
    yield put(actions.deleteBookingSuccess());
    yield put({ type: actions.LOAD_BOOKINGS_WITH_PROPERTIES, payload: { filterBooking: filterBooking } });
    yield put(actions.cleanNotificationMessage());
  } catch (error) {
    yield put(actions.deletePropertyError(error));
  }
}

function* saveBooking({ payload }) {
  const { data, actionName } = payload;
  try {
    switch (actionName) {
      case 'update':
        yield call(rsf.firestore.setDocument, `${getAccountIdPrefix() + COLLECTION_NAME_BOOKING}/${data.key}`, {
          ...omit(data, ['key', 'created_by_role']),
        });
        yield put(actions.updateBookingSuccess());
        break;
      default:
        let reservationNumber = yield getNextReservationNumber()
        data.reservation_number = reservationNumber
        yield call(rsf.firestore.addDocument, getAccountIdPrefix() + COLLECTION_NAME_BOOKING, {
          ...omit(data, ['user', 'key', 'created_by_role']),
        });
        // Notify staff when a client creates a booking
        if (data.created_by_role === 'client') {
          yield call(sendClientBookingNotification, data);
        }
        yield put(actions.saveBookingSuccess());
        break;
    }
  } catch (error) {
    console.log(error);
    yield put(actions.storeBookingError(error));
  }
}

function* sendClientBookingNotification(bookingData) {
  const bookingPayload = {
    property_id: bookingData.property_id,
    name: bookingData.name,
    surname: bookingData.surname,
    email: bookingData.email,
    start_date: bookingData.start_date,
    end_date: bookingData.end_date,
    guests: bookingData.guests,
    reservation_number: bookingData.reservation_number,
    status: bookingData.status,
    arrival_special_requirements: bookingData.arrival_special_requirements,
    departure_special_requirements: bookingData.departure_special_requirements,
    cleaning_services_special_item_list: bookingData.cleaning_services_special_item_list,
  };

  // Recipients: bookings inbox + the client that made the booking (if email present).
  // Each recipient is sent independently so a failure on one does not block the other.
  const recipients = [BOOKING_NOTIFICATION_EMAIL];
  if (bookingData.email && !recipients.includes(bookingData.email)) {
    recipients.push(bookingData.email);
  }

  const sendEmail = firebase.functions().httpsCallable('sendEmailBookingCreated');
  for (const to of recipients) {
    try {
      yield call([sendEmail, sendEmail], { to, booking: bookingPayload });
    } catch (emailError) {
      // Email failure must NOT block the booking save — log and continue
      console.warn('Client booking notification email failed for', to, emailError);
    }
  }
}

function* updateStatusBooking({ payload }) {
  const { data } = payload;
  try {
    yield call(rsf.firestore.updateDocument, `${getAccountIdPrefix() + COLLECTION_NAME_BOOKING}/${data.key}`, { status: data.status });
    yield put(actions.updateStatusBookingSuccess());
    yield put(actions.cleanNotificationMessage());
  }
  catch (error) {
    yield put(actions.updateStatusBookingError(error));
    yield put(actions.cleanNotificationMessage());
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOAD_BOOKING, loadBooking),
    takeEvery(actions.LOAD_BOOKINGS, loadBookings),
    takeEvery(actions.LOAD_BOOKINGS_WITH_PROPERTIES, loadBookingsWithProperties),
    takeEvery(actions.LOAD_ARRIVAL_DEPARTURE_WITH_PROPERTIES, loadArrivalDepartureWithProperties),
    takeEvery(actions.SAVE_BOOKING, saveBooking),
    takeEvery(actions.UPDATE_BOOKING, saveBooking),
    takeEvery(actions.UPDATE_STATUS_BOOKING, updateStatusBooking),
    takeEvery(actions.DELETE_BOOKING, deleteBooking),
    takeEvery(actions.GET_NEXT_RESERVATION_NUMBER, getNextReservationNumber),
  ]);
}
